import React, { useState } from "react";
import { predictStress } from "./api";
import "./App.css"; // Import the CSS file

const App = () => {
    const [formData, setFormData] = useState({
        Blink_Rate: "",
        RR: "",
        HRV: "",
        ST: "",
        Motion: "",
        Voice_Stress: "",
        Cortisol_Level: "",
    });

    const [prediction, setPrediction] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const result = await predictStress({
                Blink_Rate: parseFloat(formData.Blink_Rate),
                RR: parseFloat(formData.RR),
                HRV: parseFloat(formData.HRV),
                ST: parseFloat(formData.ST),
                Motion: parseFloat(formData.Motion),
                Voice_Stress: parseFloat(formData.Voice_Stress),
                Cortisol_Level: parseFloat(formData.Cortisol_Level),
            });
            setPrediction(result);
        } catch (error) {
            console.error("Error predicting stress", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="app-container">
            <div className="glassmorphism-card">
                <h1 className="app-title">Stress Prediction</h1>
                <form onSubmit={handleSubmit} className="form-container">
                    {Object.keys(formData).map((key) => (
                        <div key={key} className="form-group">
                            <label className="form-label">{key.replace("_", " ")}: </label>
                            <input
                                type="number"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="form-input"
                                required
                            />
                        </div>
                    ))}
                    <button type="submit" className="submit-button" disabled={isLoading}>
                        {isLoading ? "Predicting..." : "Predict"}
                    </button>
                </form>

                {prediction && (
                    <div className="prediction-result">
                        <h2>Prediction Result</h2>
                        <p><strong>Message:</strong> {prediction.message}</p>
                        <p><strong>Stress Score:</strong> {prediction.Stress_Score}</p>
                        <p><strong>Stress Level:</strong> {prediction.Stress_Level}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default App;